module.exports = __webpack_public_path__ + "b56cbcc991c93f4aa524ec65e45a7a08.mp4";